module.exports = __webpack_public_path__ + "media/guac_sweepstakes/submit-48b82f4a.svg";